module.exports = __webpack_public_path__ + "static/media/telegram.64dc510a.svg";